export const property = {
  gamefi: "GameFi",
  "mc_official_verify_unofficial": "Unverified Source",
  "mc_official_verify_official": "Official ",
  "mc_official_verify_fotter_tip_1": "Risk reminder to prevent online/phone fraud by fake Biking staff",
  "mc_official_verify_fotter_tip_2": "Biking Officially Declares a Risk Warning to Prevent Fraud",
  "mc_official_verify_modal_tip_1": "Your searched for [{query}] confirmed to be the official channel of Biking",
  "mc_official_verify_modal_tip_3": "Please verify that the information and the format you entered are correct:",
  "mc_official_verify_modal_tip_4": "Mobile number: xx-xxxxxxxxx",
  "mc_official_verify_modal_type_email": "Email",
  "mc_official_verify_modal_type_domain": "Domain",
  "mc_official_verify_modal_type_channel": "Channel",
  "mc_official_verify_input_placeholder": "Please enter the information and format correctly for verification",
  "mc_official_verify_head_title": "Biking Exchange Official Verification Channel | Biking Exchange",
  "mc_official_verify_head_description": "Official Verification Channel of Biking Exchange",
  "mc_official_verify_title": "Biking Verify",
  "mc_official_verify_discription_new": "On this page, you can verify whether a URL, email address, phone number, or social media account like X and Telegram, is a verified Biking official source. This will help you avoid losing your assets to phishing and online scams.",
  "mc_official_verify_fotter_tip_3": "A must-know for all Biking users: Fraud Prevention Manual. Beware of organized frauds and scams!",
  "mc_unofficial_verify_modal_tip_1": "Your search [{query}] is not a verified Biking official source",
  "mc_official_verify_discription": "In order to prevent fraud done in the name of Biking, the below is to confirm whether the channel is an official channel of Biking or not, includes but not limited to X, Facebook, Telegram, phone number and WeChat and so on.",
  "mc_official_head_title1": "Verify Biking Official Channels, News and Publications",
  "mc_official_head_keywords1": "Biking verify, Biking news, Biking official account",
  "mc_official_head_description1": "Ensure the authenticity of Biking communications. Use our official verification tool to confirm the legitimacy of channels, news, and publications related to Biking.",
  "mc_official_verify_verified_title": "Verified Official Source",
  "mc_official_verify_modal_tip_5": "Telegram/X/Facebook/Youtube: @xxxxx (with @ symbol)",
  "mc_official_verify_modal_tip_6": "TikTok/Instagram: xxxx (without @ symbol)",
  "mc_official_verify_modal_tip_7": "Discord: xxxx#xxxx (without @ symbol)",
  "mc_official_verify_modal_tip_8": "LinkedIn/Telegram group/Medium/Reddit: https://xxxxx (website link)",
  "mc_official_verify_modal_tip_9": "If you have questions about the format, please feel free to contact Customer Service.",
  "mc_official_verify_modal_tip_10": "*Do not disclose your account information and password to anyone.",
  "mc_official_verify_modal_tip_11": "*Beware of scams and operate with caution."
,
  tagtip: 'If the deposit platform does not require filling in the Comment, this field can be left blank.',
  tagtip1: 'Tag is a unique code used to identify a specific account or user, ensuring that funds are sent to the correct recipient.',
  tagtip2: 'Other trading platforms or wallets may refer to Tags as digital IDs, tags, memos, notes, remarks, etc.',
  tag: 'Please enter a comment',
  qbcbcg: 'Please copy both the TON address and comment to ensure successful deposit.',
  qsrzqje: "Please enter the correct amount.",
  games: 'Gaming Account',
  cbxz: 'Deposit Notice for Ethereum (ERC20)',
  tbxz: 'Withdrawal Notice for Ethereum (ERC20)',
  ctbzysx: 'Please note that there is an additional 2% fee for each transfer from the official FUFU smart contract.',
  dzcw: 'wrong address',
  czqkqrs: "Deposit block confirmation number",
  mc: 'Name',
  cjsj: 'Creation Time',
  lx: 'Type',
  sl: 'Quantity',
  cwjl: 'Financial History',
  ylzh: 'Profit',
  ddtx: 'Waiting for withdrawal',
  txcg: 'Successful withdrawal',
  yhcx: 'User cancel',
  qbcbjl: 'All deposit records',

  zczl: 'Asset Overview',
  zjzh: 'Funding Account',
  mbzh: 'C2C Account',
  xhzh: 'Spot Account',
  hyzh: 'Futures account',
  lczh: 'Earn account',
  gdzh: 'Copy Account',
  giftzh: 'Bonus Account',
  bwzh: 'Biking Card',
  mozh: 'Ghost Card',
  mnhy: 'Simulated Futures',
  sxffy: 'System Rebate',
  kt: 'Airdrop',
  xtkc: 'System Deduction',
  zcfb: 'Asset Distribution',
  zcdt: 'Asset Dynamics',
  zh: 'Account',
  zc: 'Asset',
  czjl: 'Deposit History',
  txls: 'Withdrawal History',
  hzjl: 'Transfer History',
  mmjl: 'Buy and sell records',
  cb: 'Deposit',
  tx: 'Withdraw',
  hz: 'Transfer',
  mb: 'Buy',
  jy: 'Trade',
  zwsj: 'No data yet',
  ckqb: 'View all',

  // table
  bz: 'Currency',
  qc: 'Full name',
  zhze: 'Total Assets',
  syzc: 'Available',
  djzc: 'In orders',
  cz: 'Operation',
  sl: 'Quantity',
  cbdz: 'Deposit address',
  sj: 'time',
  zt: 'status',
  ms: 'Description',
  hzfx: 'Swipe direction',
  hzse: 'Transfer amount',
  txdz: 'Withdrawal address',
  sxf: 'fee',
  ddh: 'Order number',
  zj: 'Total price',
  dj: 'Unit price',
  jysl: 'Transaction Quantity',
  jydx: 'Trading object',
  zhqy: 'Account Equity',
  zhqytips: 'Account Equity = Available + Position Margin',
  kybzj: 'Available',
  kybzjtips: 'The margin that can be used to open and transfer out',
  cwbzj: 'Position Margin',
  cwbzjtips: 'Margin for maintaining existing positions',


  // search
  srbz: 'Please enter the corresponding currency',
  ycxzc: 'Hide small balances',
  sy: 'All',
  qb: 'All',
  qx: 'All',
  zhi: 'to',
  ksrq: 'start date',
  jsrq: 'end date',
  cx: 'Query',
  dc: 'Export',
  zjqt: 'The last 7 days',
  zjygy: 'The last month',
  qbsj: 'All time',
  usdt: 'USDT',
  ddlx: 'order type',
  gm: 'Buy',
  cs: 'Sale',

  // recharge
  czxq: 'Recharge details',
  usdtcbjl: '{coinName} deposit record',
  cbsl: 'Amount of deposit',
  cbzt: 'Deposit status',
  crdbz: 'Please select the currency you need to deposit',
  tqdbz: 'Please select the currency you need to withdraw',
  rmbz: 'Hot currency',
  qxz: 'Please choose',
  cbwl: 'Coin deposit network',
  cbtips: 'Please make sure you have selected the same network as the withdrawal platform for depositing, otherwise it will cause asset loss. ',
  txfs: 'Withdrawal method',
  lstx: 'On-chain withdrawal',
  xyb: 'Next',
  yxzdq: 'Currently selected',
  dbz: 'The currency',
  cxxz: 'Reselect',
  dzkbz: 'Insufficient addresses in the address library, please contact the administrator',
  qxzcrdbz: 'Please select the currency to deposit first',
  qxzcbwl: 'Please select a deposit network',
  qxztqdbz: 'Please select the withdrawn currency first',
  cr: 'charge',
  tq: 'extract',
  cbxq: 'Deposit details',
  txxq: 'Withdrawal details',
  usdttxjl: '{coinName} withdrawal record',
  qbtxjl: 'All withdrawal records',
  zyxx: 'Important information: You can only send {coinName} to this address, if you send other digital currencies, you will lose the funds. ',
  jzjcr: 'Add funds to',
  smewm: 'Scan the QR code or copy the following information to the sending platform',
  xcdzcz: 'Recharging non-this type of currency to this address will make your assets irretrievable',
  xcdzczss: 'When depositing XRP, please make sure to copy the tag, otherwise it may cause loss of funds.',
  znhycz: 'Smart Contract Recharge, Package Recharge, Block Reward Recharge is not currently supported',
  usdtcbdz: '{usdtcbdz} deposit address',
  fzdz: 'copy address',
  usdtdz: '{coinName} address',
  zxcbe: 'Minimum deposit amount',
  zytx2: 'Important: Please make sure the receiving platform supports the {coinName} network of your choice, otherwise you will lose this funds. ',
  kytxwl: '{coinName} withdrawal network available',
  xzwl: 'Select network',
  dzym: '{coinName} address',
  srdz: 'Enter address or select from address book',
  jymm: 'Transaction password',
  qsrjymm: 'Please enter the transaction password',
  zxtbe: 'Minimum withdrawal amount: {minAmount}',
  ky: 'Available:',
  zhztbxe: 'Account total withdrawal limit',
  gjxyddj: 'According to your verification level, you can only withdraw a limited amount of coins within 24 hours. The limit will be calculated in USD converted to the digital currency of your choice. ',
  scbdjd: 'Due to the large fluctuations in the currency price, the handling fee of this currency is a floating handling fee. According to the average currency price in the previous 24 hours, a handling fee equivalent to 0.2-0.2 USDT will be charged to increase the handling fee to increase the speed of arrival',
  yqdz: 'Expected arrival',
  yqdzwf: 'The expected arrival cannot be negative',
  sfrz: 'Authentication',
  ggyzm: 'Google authentication code',
  dxyzm: 'SMS verification code',
  yxyzm: 'Email verification code',
  qsryzm: 'Please enter the verification code',
  fsyzm: 'Send',
  cxfs: 'resend',
  tj: 'Submit',
  qxztxwl: 'Please select a withdrawal network',
  qsrdz: 'Please enter the address',
  qxzdz: 'Please select an address',
  qxzyzfs: 'Please choose an identity authentication method',
  qsrtqsl: 'Please enter the quantity to extract',
  qwcyz: 'Please complete the verification',
  qqrbdsj: 'Please confirm whether to bind the mobile phone first',
  qqrbdyx: 'Please confirm whether to bind the mailbox first',
  fzcg: 'Copy successfully! ',
  tbcg: 'Withdrawal succeeded',
  usdttxdz: '{coinName} withdrawal address',
  lmc: 'Chain name:',
  qtj: '*Please add',
  dz: 'address',
  fei: 'non',
  zjds: 'The address may cause asset loss',
  yzfs: 'Authentication method',
  yzm: 'Verification code',
  remark: 'remark',
  qsrremark: 'Please enter a comment',
  tjdzcg: 'add address successfully',
  qxxzyzfs: 'Please select the verification method first',
  qsrtxdz: 'Please enter the withdrawal address',
  stop: 'Pause',

  // status
  qr0: '0 confirmation',
  qr1: '1 confirmation',
  dqr: 'to be confirmed',
  czcg: 'Recharge successful',
  hzz: 'Transferring',
  ywc: 'Completed',
  sb: 'failure',
  zzcl: 'processing',
  ddsh: 'waiting for review',
  txcg: 'Withdrawal successful',
  cxcg: 'Undo successful',
  ddtx: 'waiting for withdrawal',
  txsb: 'Withdrawal failed',
  slsb: 'Failed to upload',
  dfk: 'to be paid',
  yfk: 'Paid',
  yqx: 'Cancelled',
  ssz: 'Appealing',
  gdfrhz: 'Margin transfer with the order',
  hyzh_to_gdzh: 'Contract account - documentary account',
  gdzh_to_hyzh: 'Documentary Account - Contract Account',
  ddcl: 'waiting for processing',
  cg: 'Success',

  // dialog
  zchz: 'Asset transfer',
  ljhz: 'Transfer immediately',
  cong: 'from',
  dao: 'to',
  qtzh: 'Other accounts',
  qxzbz: 'Please select currency',
  qsrsl: 'Please enter the quantity',
  khz: 'Can be transferred:',
  ye: 'Balance:',
  hzcg: 'Transfer successful',

  // h5
  zcgl: 'Asset Overview',
  xrzx: 'Exclusive for newcomers',
  zzc: 'Total Assets',
  jryk: "Today's profit and loss",
  zgjz: 'The highest value 3200 USDT gift package for newcomers is waiting for you',
  zhrj: 'Deposit funds into your account',
  xzrjfs: 'You can buy digital currency after depositing, and you can choose the deposit method according to the actual situation',
  czszhb: 'Recharge digital currency',
  yyydszhb: 'Recharge the digital currency you already have on other platforms into your Biking account. ',
  czfb: 'Recharge legal currency',
  czzhz: 'Recharge the legal currency you already have into the Biking account, support bank cards, transfers and other payment methods',
  maibi: 'Buy Coins',
  tgdsfmb: 'Purchase digital currency through bank cards, P2P, third parties, etc.',
  yqyl: 'The invitation is polite',
  yqfy: 'Invite friends to enjoy 20% rebate',
  cxzzn: "Beginner's Guide",
  czzh: 'Create a Biking account',
  hdxrj: 'Get 100USDT newcomer bonus',
  ck: 'Deposit',
  tzndzh: 'Invest in your account, start your journey, support multiple payment methods',
  wcsfrz: 'Complete identity verification (KYC)',
  hgzh: 'Complete identity verification (KYC) and become a compliant account',
  ksjy: 'Start trading',
  tsgd: 'Sell, buy or copy transactions, explore more',
  ksndlc: 'Begin your journey',
  kjydjmhb: 'Tradable cryptocurrency',
  jmhb: 'The total value of cryptocurrencies is 1228.485 billion US dollars',


  批量导入地址:'Import addresses in batches',
  请输入地址或名称:'Please enter an address or name',
  地址名称:'Address Name',
  上传普通地址:'Upload normal address',
  上传成功:'Upload Successfully',
  一次只能上传一个文件哦:'Only one file can be uploaded at a time',
  文件大小不得超过10M:'The file size must not exceed 10M',
  请先选择要上传的文件:'Please select the file to upload first',
  只能上传后缀是:'You can only upload files with the suffix .xlsx or .xls or .csv',
  将文件拖到此处:'Drag your files here, or',
  点击上传:'Click Upload',
  最大1MB:'CSV, XLS, XLSX files up to 1MB',
  编号:'Number',
  所属网络:'Network',
  地址簿:'Address book',
  新增地址:'Add address',
  提币地址一次不超过100个:'The number of withdrawal addresses at a time shall not exceed 100.',
  添加地址:'Add address',
  保存地址:'Save address',
  下载模板:'Download the template',
  批量提现:'Batch withdrawal',
  请输入Memo:'Please enter Memo',
  请输入地址名称:'Please enter the address name',
  您可以通过:'You can upload up to 20 common addresses via CSV, XLS or XLSX format files (maximum 1MB). The headers of each column must be consistent with the template, otherwise the upload will fail.',
  输入正确地址可添加地址成功:'Enter the correct address to add the address successfully',
  zengjin: "Gift",
  lc: "Financial Management",
  mb: "Buy Coins",
  lsjl: "Historical Records",
  zclb: "Asset List",
  shaixuan: "Screening",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/property/en.js